// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vi8Kwp4eFYMT5w3xgzdQ{display:inline-flex;align-items:end}`, "",{"version":3,"sources":["webpack://./web/src/components/common/ProductDisplay/ProductDisplay.module.scss"],"names":[],"mappings":"AAAA,sBACI,mBAAA,CACA,eAAA","sourcesContent":[".root {\n    display: inline-flex;\n    align-items: end;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `vi8Kwp4eFYMT5w3xgzdQ`
};
export default ___CSS_LOADER_EXPORT___;
